import * as runtime from "@baseline/runtime";
import React from "react";
import { Context } from "./context";


export function useContext(): runtime.Context
{
    return React.useContext(Context.ref);
}
